/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Perfil } from "../../../types/admin-usuarios/Perfil";
import { Sistema } from "../../../types/admin-usuarios/Sistema";
import InputSearch from "../../../components/inputs/InputSelectSearch";

const defaultForm: Perfil = {
    name: "",
    system: "",
};

const formSchema = Yup.object().shape({
    name: Yup.string().required("Ingrese un nombre para el perfil"),
    system: Yup.string().required("Seleccione un sistema")
});

export default function Form({setOpen, selected} : {setOpen: any, selected?: Perfil}) {
    const [loading, setLoading] = useState<boolean>(true);
    const [sistemas, setSistemas] = useState<Sistema[]>([]);

    const {
        handleSubmit,
        handleReset,
        handleBlur,
        setFieldValue,
        setValues,
        values,
        errors,
        touched,
    } = useFormik({
        initialValues: defaultForm,
        validationSchema: formSchema,
        onSubmit: (values) => {
            swalAction(
                save, 
                `${selected? "Editar" : "Guardar"} Perfil`, 
                `¿Desea ${selected? "editar" : "guardar"} este perfil?`, 
                "question"
            )
        },
        onReset: () => {setOpen(false)},
    });

    function onChange({ target }: { target: any }) {
        setFieldValue(target.name, target.value);
    }

    useEffect(()=>{
        getSistemas();
        if(selected) setValues({
            name: selected.name,
            system: (selected.system as Sistema)._id || selected.system
        }, true);
    }, []);

    async function getSistemas(){
        const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
        if(res) setSistemas(res.data);
        setLoading(false);
    }

    async function save(){
        const method = selected ? "PUT" : "POST";
        const rute = selected ? `/${selected._id}` : "";
        setLoading(true);
        const res = await peticionBack(values, "/perfiles" + rute, method, true, toaster);
        if(res) handleReset(null);
        setLoading(false);
    }

    return (
        <form onSubmit={handleSubmit} onReset={handleReset}>
            <Row>
                <Col xs={12} md={6}>
                    <InputForm
                        label="Nombre"
                        name="name"
                        type="text"
                        value={values.name}
                        touched={touched.name}
                        error={errors.name}
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Sistema"
                        name="system"
                        value={values.system as string}
                        touched={touched.system}
                        error={errors.system}
                        values={sistemas}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
            </Row>

            <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
                <Button variant="danger" type="reset">
                    Cancelar
                </Button>
                <Button variant="success" type="submit">
                    Guardar
                </Button>
            </div>

            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </form>
    )
}